// extracted by mini-css-extract-plugin
module.exports = {"container":"HideContentIcon_container__1NinP"};